import { IMPORTANCE_LEVEL } from '../types'

/**
 * Önem Derecesi id → rozet sınıfı. <b>Renk id'den gelir, addan DEĞİL</b>: ad {@code REFERANS}'ta
 * değiştirilebilir (statü adlarında bir kez yaşandı) ve dile göre de değişir; metin eşleşmesine bağlı
 * bir renk o gün sessizce griye düşerdi. Eşlemesi olmayan/boş id nötr (Normal) tonu alır.
 */
const TONE_CLASS: Record<number, string> = {
  [IMPORTANCE_LEVEL.VERY_IMPORTANT]: 'act-badge--imp-high',
  [IMPORTANCE_LEVEL.NORMAL]: 'act-badge--imp-normal',
  [IMPORTANCE_LEVEL.LESS_IMPORTANT]: 'act-badge--imp-low',
}

interface Props {
  levelId: number | null | undefined
  /** Dile-duyarlı Önem Derecesi adı (sunucuda REFERANS'tan çözülür). Boşsa rozet çizilmez. */
  name: string | null | undefined
}

/**
 * Önem Derecesi rozeti (kullanıcı isteği 2026-08-28: tablo kolonları düz metin yerine rozet gösterir).
 * Statü rozetiyle ({@code ActionStatusTag}) aynı taban sınıfı ({@code .act-badge}) kullanır — iki kolon
 * yan yana durduğu için ölçü/kenar yuvarlaması ortak olmalı; ayrışan tek şey renk çiftidir.
 *
 * <p>Ad sunucudan gelir; <b>ad yoksa rozet de yoktur</b> (boş hücre) — önceki düz metin davranışıyla aynı,
 * içi boş bir pill çizilmez.
 */
export default function ImportanceBadge({ levelId, name }: Readonly<Props>) {
  const label = name?.trim()
  if (!label) return null
  const cls = (levelId != null ? TONE_CLASS[levelId] : undefined) ?? 'act-badge--imp-normal'
  return <span className={`act-badge ${cls}`}>{label}</span>
}
